/**
 * A layout column.
 *
 * -- Props --
 * | Name       | Type    | Required  | Default Value | Description
 * |------------|---------|-----------|---------------|---------------
 * | id         | string  | false     | null          | An id to apply to this component.
 * | className  | string  | false     | ""            | Additional classes to apply to this component.
 */
export const Column = (props) => {
  return (
    <div id={props.id || null} className={`column${props.className ? " " + props.className : ""}`} style={props.style}>
      {props.children}
    </div>
  );
}

export default Column;